import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MessageSquare, Settings, User, LogOut, PhoneCall, Shield } from "lucide-react";
import { toast } from "sonner";

export const AppHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const handleLogout = () => {
    localStorage.removeItem('fruitycall_auth');
    localStorage.removeItem('fruitycall_user');
    toast.success("Déconnexion réussie");
    navigate("/login");
  };
  
  const navItems = [
    { name: "Messages", path: "/app/messages", icon: MessageSquare },
    { name: "Réception", path: "/app/voice-config", icon: PhoneCall },
    { name: "Paramètres", path: "/app/settings", icon: Settings },
    { name: "Profil", path: "/app/profile", icon: User },
    { name: "Admin", path: "/app/admin/numbers", icon: Shield },
  ];
  
  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + "/");
  
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background">
      <nav className="container-custom flex h-16 items-center justify-between">
        {/* Logo */}
        <Link to="/app/messages" className="flex items-center space-x-2">
          <span className="text-2xl">🍓</span>
          <span className="text-xl font-bold text-foreground">Fruitycall</span>
        </Link>
        
        {/* Navigation */}
        <div className="flex items-center gap-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link key={item.path} to={item.path}>
                <Button
                  variant={isActive(item.path) ? "default" : "ghost"}
                  size="sm"
                  className="gap-2"
                >
                  <Icon className="h-4 w-4" />
                  <span className="hidden sm:inline">{item.name}</span>
                </Button>
              </Link>
            );
          })}
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            className="gap-2 text-destructive hover:text-destructive"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Déconnexion</span>
          </Button>
        </div>
      </nav>
    </header>
  );
};